import { createContext, useContext } from "react";

export const LangContext = createContext("de");
export const useLang = () => useContext(LangContext);

export const UI = {
  de: {
    optional: "(optional)",
    privacyPre: "Ich habe die ",
    privacyLink: "Datenschutzhinweise",
    privacyPost: " zur Kenntnis genommen. Meine Angaben werden zur Bearbeitung meiner Anfrage verarbeitet.",
    honeypot: "Website (bitte leer lassen)",
    reference: "Ihre Referenznummer:",
    reset: "Weitere Angaben senden",
    filesLabel: "Lebenslauf und berufliche Nachweise",
    drop: "Dateien hierher ziehen oder",
    choose: "Dateien auswählen",
    filesHint: "PDF, JPG, PNG oder DOCX · max. 10 MB pro Datei · bis zu 5 Dateien. Bitte keine Passkopien oder Gesundheitsunterlagen hochladen.",
    remove: (n) => `${n} entfernen`,
    typeErr: (n) => `„${n}“: Erlaubt sind nur PDF, JPG, PNG oder DOCX.`,
    sizeErr: (n) => `„${n}“ ist größer als 10 MB.`,
    countErr: "Höchstens 5 Dateien möglich.",
    noConnection: "Keine Verbindung zum Server. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    genericError: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  },
  en: {
    optional: "(optional)",
    privacyPre: "I have read the ",
    privacyLink: "privacy information (in German)",
    privacyPost: ". My details will be processed to handle my registration.",
    honeypot: "Website (please leave empty)",
    reference: "Your reference number:",
    reset: "Submit another registration",
    filesLabel: "CV and professional certificates",
    drop: "Drag files here or",
    choose: "Choose files",
    filesHint: "PDF, JPG, PNG or DOCX · max. 10 MB per file · up to 5 files. Please do not upload passport copies or health documents.",
    remove: (n) => `Remove ${n}`,
    typeErr: (n) => `“${n}”: only PDF, JPG, PNG or DOCX files are allowed.`,
    sizeErr: (n) => `“${n}” is larger than 10 MB.`,
    countErr: "A maximum of 5 files is possible.",
    noConnection: "No connection to the server. Please check your internet connection and try again.",
    genericError: "Something went wrong. Please try again.",
  },
};
